import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colours } from '../tokens';
import SVG from './SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
    fill: {
        transition: ['fill', '0.2s', 'linear']
    }
});
const ConfirmationIcon = ({ className, fill }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "512", height: "320", viewBox: "0 0 320 512", className: classNames(styles.root, className) },
        React.createElement("path", { className: styles.fill, fill: fill, d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" })));
};
export default ConfirmationIcon;
//# sourceMappingURL=CaretIcon.js.map